/**
 * The two bytes a peer proves it is still running with.
 *
 * A ping carries the sender's own stamp and a pong echoes it back untouched, so a round trip is
 * measured against one clock rather than agreed between two. That is the same trick the hello frame
 * uses for how long a host has held its claim: nothing on the wire is a point in time, only a
 * duration or a number to hand straight back.
 *
 * Four bytes, wrapping every 49 days. Whoever measures a round trip subtracts in the same 32 bits
 * the stamp was written in, so the one wrap a long session crosses costs nothing.
 */

import { createReader, createWriter } from '@/net/wire/byteCursor';

/** What a ping and a pong each carry: one `uint32` of the pinging side's own milliseconds. */
export const HEARTBEAT_BYTES = 4;

/** A stamp, wrapped into the four bytes that carry it. */
export function encodeHeartbeat(stampMs: number): Uint8Array {
  const writer = createWriter(HEARTBEAT_BYTES);
  writer.u32(Math.trunc(stampMs) >>> 0);
  return writer.bytes();
}

/** Throws `NetError('malformedFrame')` on a payload too short to hold one, as every codec does. */
export function decodeHeartbeat(payload: Uint8Array): number {
  return createReader(payload).u32();
}
